define('app/sds/bill/summary/sds-bill-summary',["service!selcomm", "linq"], function (SelcommWS, Enumerable) {
	/// <param name="Enumerable" value="window.Enumerable" />
	"use strict";
	return {
		scope: {
			"billRef": "="
		},
		controller: ["$scope", function ($scope) {
			$scope.typeTotal = function (type) {
				return Enumerable.From($scope.billSummary[type]).Sum(function (i) { return i.AmountTaxEx; });
			}
			$scope.total = function () {
				var total = 0;
				for (var type in $scope.billSummary) {
					if ($scope.billSummary.hasOwnProperty(type)) {
						total += $scope.typeTotal(type);
					}
				}
				return total;
			}


			$scope.$watch(function () { return { BillId: $scope.billRef }; }, function (requestData) {
				SelcommWS.get("Bill", "BillSummaryItemList", requestData).then(function (billSummaryItems) {
					$scope.billSummary = {};
					Enumerable
						.From(billSummaryItems)
						.GroupBy(function (i) { return i.Type; })
						.ForEach(function (g) {
							$scope.billSummary[g.Key()] = g.source;
						});
					arguments;
				});
			}, true);
		}]
	}
});
